import React from 'react';
import { string, shape, arrayOf } from 'prop-types';

import { useBLazyRevalidate } from 'hooks';
import { BaseCard } from 'components/cards';
import { LISTING_CONTAINER_ID } from '../constants';

const LocationsListing = ({ items }) => {
    useBLazyRevalidate(LISTING_CONTAINER_ID, [items]);

    if (!items || !items.length) {
        return null;
    }

    return (
        <div className="grid grid--cards grid--equal-height grid--cards--large-v-gutter">
            {items.map(item => (
                <div className="col-lg-4 col-sm-6" key={item.id}>
                    <BaseCard {...item} />
                </div>
            ))}
        </div>
    );
};

LocationsListing.propTypes = {
    items: arrayOf(
        shape({
            id: string,
            image: shape({ url: string, alt: string }).isRequired,
            target: string,
            title: string.isRequired,
            url: string.isRequired
        })
    ).isRequired
};

export default LocationsListing;
